import React from 'react';
import { Link } from 'react-router-dom';
import './Industries.css';
import SEO from '../../components/SEO/SEO';


const industriesData = [
    {
        id: 'healthcare',
        icon: '🏥',
        title: 'Healthcare',
        description: 'Digital marketing solutions for hospitals, clinics, medical practices, and healthcare providers.',
        link: '/industries/healthcare',
        features: ['Patient Acquisition', 'HIPAA Compliant Marketing', 'Reputation Management', 'Local SEO']
    },
    {
        id: 'real-estate',
        icon: '🏠',
        title: 'Real Estate',
        description: 'Drive property sales and rentals with targeted marketing for realtors and real estate agencies.',
        link: '/industries/real-estate',
        features: ['Property Listings SEO', 'Virtual Tours', 'Lead Generation', 'Market Analysis']
    },
    {
        id: 'ecommerce',
        icon: '🛒',
        title: 'E-Commerce',
        description: 'Increase online sales with conversion-optimized strategies for online retailers.',
        link: '/industries/e-commerce',
        features: ['Product SEO', 'Shopping Ads', 'Conversion Rate Optimization', 'Email Automation']
    },
    {
        id: 'legal',
        icon: '⚖️',
        title: 'Legal',
        description: 'Attract high-value clients for law firms, attorneys, and legal service providers.',
        link: '/industries/legal',
        features: ['Legal SEO', 'Client Acquisition', 'Content Marketing', 'Reputation Management']
    },
    {
        id: 'fitness',
        icon: '💪',
        title: 'Fitness & Wellness',
        description: 'Grow memberships and class bookings for gyms, studios, and wellness centers.',
        link: '/industries/fitness',
        features: ['Local Marketing', 'Membership Growth', 'Class Booking Systems', 'Social Media']
    },
    {
        id: 'saas',
        icon: '💻',
        title: 'SaaS & Technology',
        description: 'Scale your software business with demand generation and product marketing strategies.',
        link: '/industries/saas',
        features: ['Product Marketing', 'Lead Generation', 'Demo Bookings', 'Content Strategy']
    },
    {
        id: 'dental',
        icon: '🦷',
        title: 'Dental',
        description: 'Attract new patients and fill appointment calendars for dental practices.',
        link: '/industries/dental',
        features: ['Patient Acquisition', 'Appointment Booking', 'Local SEO', 'Review Management']
    },
    {
        id: 'automotive',
        icon: '🚗',
        title: 'Automotive',
        description: 'Drive showroom traffic and online sales for dealerships and auto service centers.',
        link: '/industries/automotive',
        features: ['Inventory Marketing', 'Service Bookings', 'Local Listings', 'Video Marketing']
    },
    {
        id: 'hospitality',
        icon: '🏨',
        title: 'Hospitality',
        description: 'Increase bookings and reservations for hotels, restaurants, and travel services.',
        link: '/industries/hospitality',
        features: ['Booking Optimization', 'Guest Reviews', 'Seasonal Campaigns', 'OTA Marketing']
    },
    {
        id: 'education',
        icon: '🎓',
        title: 'Education',
        description: 'Boost enrollments for schools, universities, training centers, and online courses.',
        link: '/industries/education',
        features: ['Student Enrollment', 'Course Marketing', 'Campus Tours', 'Program Promotion']
    },
    {
        id: 'financial',
        icon: '💰',
        title: 'Financial Services',
        description: 'Build trust and acquire clients for banks, advisors, and financial institutions.',
        link: '/industries/financial',
        features: ['Lead Generation', 'Compliance Marketing', 'Trust Building', 'Client Retention']
    },
    {
        id: 'home-services',
        icon: '🔧',
        title: 'Home Services',
        description: 'Generate service requests for contractors, plumbers, electricians, and home repair.',
        link: '/industries/home-services',
        features: ['Local SEO', 'Service Area Pages', 'Emergency Services', 'Review Generation']
    }
];

const Industries = () => {
    return (
        <div className="industries-page">
            <SEO
                title="Industries We Serve | Healthcare, Real Estate, E-Commerce & More"
                description="Digi Network provides specialized digital marketing strategies for 12+ industries, including Healthcare, SaaS, Real Estate, and more."
                canonical="/industries"
            />
            {/* Hero Section */}
            <section className="industries-hero">
                <div className="industries-hero-bg"></div>
                <div className="container">
                    <div className="industries-hero-content">
                        <div className="label">INDUSTRIES WE SERVE</div>
                        <h1>Industry-Specific Digital Marketing</h1>
                        <p>We understand that every industry has unique challenges, regulations, and customer behaviors. Our specialized marketing strategies are tailored to drive results in your specific market.</p>
                        <Link to="/contact" className="btn btn-primary">
                            Discuss Your Industry
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Industries Stats */}
            <section className="industries-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">12+</div>
                            <div className="stat-label">Industries Served</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">500+</div>
                            <div className="stat-label">Industry Clients</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">85%</div>
                            <div className="stat-label">Client Retention Rate</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">3x</div>
                            <div className="stat-label">Average ROI Growth</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Industries Grid */}
            <section className="industries-grid-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Industries We Specialize In</h2>
                        <p>Click on any industry to explore our specialized marketing solutions</p>
                    </div>

                    <div className="industries-grid">
                        {industriesData.map((industry) => (
                            <Link to={industry.link} key={industry.id} className="industry-card">
                                <div className="industry-card-icon">{industry.icon}</div>
                                <h3>{industry.title}</h3>
                                <p className="industry-card-description">{industry.description}</p>

                                <ul className="industry-features">
                                    {industry.features.map((feature, index) => (
                                        <li key={index}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <circle cx="8" cy="8" r="8" fill="#0037FC" opacity="0.1" />
                                                <path d="M5 8L7 10L11 6" stroke="#0037FC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>

                                <div className="industry-card-link">
                                    Learn More
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Industry-Specific */}
            <section className="why-industry-specific">
                <div className="container">
                    <h2>Why Industry-Specific Marketing Matters</h2>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <div className="benefit-icon">🎯</div>
                            <h3>Deep Market Understanding</h3>
                            <p>We know your customers, competitors, and market dynamics inside and out.</p>
                        </div>
                        <div className="benefit-item">
                            <div className="benefit-icon">📊</div>
                            <h3>Industry Best Practices</h3>
                            <p>Proven strategies that work specifically in your industry, not generic approaches.</p>
                        </div>
                        <div className="benefit-item">
                            <div className="benefit-icon">⚖️</div>
                            <h3>Compliance & Regulations</h3>
                            <p>Navigate industry-specific regulations like HIPAA, FINRA, or FTC guidelines.</p>
                        </div>
                        <div className="benefit-item">
                            <div className="benefit-icon">💡</div>
                            <h3>Specialized Messaging</h3>
                            <p>Industry-specific language and positioning that resonates with your audience.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="industries-cta">
                <div className="container">
                    <div className="industries-cta-content">
                        <h2>Ready to Dominate Your Industry?</h2>
                        <p>Let's discuss how our industry-specific strategies can drive growth for your business.</p>
                        <Link to="/contact" className="btn btn-primary">
                            Get a Free Industry Analysis
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Industries;
